module.exports = __webpack_public_path__ + "img/pin_take_away_green.f0192352.svg";